import React from "react";

/**
 * Teléfonos y correo de apoyo para agendar (inicio / panel cliente).
 */
export default function BookingSupportContactCard({ className = "" }) {
  return (
    <div
      className={`rounded-xl bg-brand-lilac/40 border border-brand-lavender/20 p-5 sm:p-6 text-brand-dark/90 ${className}`.trim()}
    >
      <p className="font-medium text-brand-dark mb-2">
        Si necesitas ayuda para agendar una cita, contáctanos por teléfono:
      </p>
      <p className="mb-2">
        <a href="tel:8006819591" className="text-brand-lavender font-semibold hover:underline">
          800 681 9591
        </a>
        {" / "}
        <a href="tel:3341708343" className="text-brand-lavender font-semibold hover:underline">
          334 170 8343
        </a>
      </p>
      <p className="mb-2">
        o escribe a{" "}
        <a
          href="mailto:contacto@eapconsulting.mx"
          className="text-brand-lavender font-semibold hover:underline break-all"
        >
          contacto@eapconsulting.mx
        </a>
      </p>
      <p className="text-brand-gray text-sm">
        Nuestro equipo te ayudará con lo que necesites.
      </p>
    </div>
  );
}
